<template>
	<div class="page">
		<van-list :error.sync="error" error-text="请求失败，点击重新加载" v-model="loading" :finished="finished" finished-text="已加载完毕"
		 @load="loadData">
			<div @click="handleClick(item)" v-for="item in list" :key="item.id" class="item" :style="{'background-image' :'url('+ (item.imgUrl || 'https://img.xtejia.com/paiqian/bg-zhinan.png') +')'}">
				<div class="title-wrapper">
					<div class="title">{{item.title}}</div>
					<div class="content">{{item.simpleContent}}</div>
				</div>
			</div>
		</van-list>

	</div>
</template>
<style scoped="scoped">
	.page {
		padding: 20px;
		box-sizing: border-box;
	}

	.item {
		width: 100%;
		max-width: 100%;
		height: 150px;
		position: relative;
		display: flex;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		justify-content: center;
		align-items: center;
		border-radius: 5px;
		/* box-shadow: 1px 11px 14px 1px rgba(0, 0, 0, 0.28); */
		margin-bottom: 25px;
	}

	.item .title-wrapper {
		height: 45%;
		width: 60%;
		background: rgba(255, 255, 255, 0.88); 
		overflow: hidden;
		font-size: 12px;
		padding: 8px 10px;
		text-align: center;
		border-radius: 1px;
	}

	.item .title-wrapper .title {
		font-weight: 900;
		font-size: 20px;
	}
</style>
<script>
	import {
		getList
	} from '@/api/news.js'
	import nativeApi from '@/utils/native-bridge'

	export default {
		name: 'ZhiNan',
		components: {},
		data() {
			return {
				query: {
					limit: 20,
					page: 0,
					type: 20
				},
				list: [],
				loading: false,
				finished: false,
				error: false
			}
		},
		methods: {
			handleClick(item) {
				if (item.linkUrl) {
					nativeApi.forwardPage({
						uri: item.linkUrl
					})
				}
			},
			loadData() {
				this.loading = true;
				const targetPage = this.query.page + 1;
				getList(Object.assign({}, this.query, {
					page: targetPage
				})).then(({
					data
				}) => {
					this.query.page = targetPage;
					if (data.items && data.items.length) {
						this.list = this.list.concat(data.items)
						this.loading = false;
					} else {
						this.finished = true;
						this.loading = false;
					}
				}).catch((rep) => {
					this.error = true;
					this.loading = false;
				})
			}
		},
		created() {
			// this.loadData();
		}
	}
</script>
